export const StorageKeys = {
  googleMapsApiKey: 'googleMapsApiKey',
  fuelTypes: 'fuelTypes',
  selectedFuelType: 'selectedFuelType',
};

export const Platforms = {
  device: 'device',
  web: 'web',
};

export const BennettsStationCodes = [
  '382',
  '235',
  '34',
  '184',
  '179',
  '182',
  '20021',
  '390',
  '392',
  '391',
  '178',
  '186',
  '181',
  '183',
  '20020',
  '187',
  '185',
  '180',
];

export const BonneyStationCodes = [
  '125',
  '126',
  '127',
  '380',
  '128',
  '129',
  '130',
  '132',
  '133',
  '135',
  '20027',
  '20010',
  '137',
  '138',
  '20040',
  '139',
  '194',
  '20005',
  '42',
  '20008',
  '141',
  '142',
  '20009',
  '20037',
  '20033',
  '20046',
  '20034',
  '20039',
  '20049',
  '20048',
  '20055',
];

export const PartnerDiscount = 6;
